/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Lambdas } from './lambdas';
import { EC2Instance } from './eC2Instance';
import { S3Bucket } from './s3Bucket';
import { ShadowAccountAMIList } from './shadowAccountAMIList';
import { Network } from './network';
import { RDSInstances } from './rDSInstances';
import { RDSDbSubnet } from './rDSDbSubnet';


export interface AWSResourceInfo { 
    ami_list?: ShadowAccountAMIList;
    dynamodb_table?: Array<string>;
    ec2_instances?: Array<EC2Instance>;
    lambda_triggers?: Array<string>;
    lambdas?: Array<Lambdas>;
    network?: Array<Network>;
    rds_cluster?: Array<string>;
    rds_instances?: Array<RDSInstances>;
    rds_subnets?: Array<RDSDbSubnet>;
    s3_buckets?: Array<S3Bucket>;
}

